<div class="container">
  <div class="buttons-container">
    <button mat-raised-button
            action-button
            color="primary"
            [action]="findInGus.bind(this)">
      Wyszukaj dane firmy w bazie GUS
    </button>
  </div>
  <form [formGroup]="companyForm">
    <mat-form-field appearance="outline">
      <mat-label>Nazwa</mat-label>
      <input matInput formControlName="companyName" required/>
      <mat-error *ngIf="companyForm.get('companyName').hasError('required')">
        Podaj nazwę firmy
      </mat-error>
    </mat-form-field>
    <div class="double-field-container">
      <mat-form-field appearance="outline">
        <mat-label>NIP</mat-label>
        <input matInput formControlName="nip" [matAutocomplete]="auto"/>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="chooseCompany($event.option.value)">
          <mat-option *ngFor="let company of filteredCompanies | async" [value]="company">
            {{company.toSelectText()}}
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="companyForm.get('nip').hasError('maxlength') ||
                          companyForm.get('nip').hasError('minlength') ||
                          companyForm.get('nip').hasError('pattern')">
          Niepoprawny numer NIP
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>REGON</mat-label>
        <input matInput formControlName="regon"/>
        <mat-error *ngIf="companyForm.get('regon').hasError('maxlength') ||
                          companyForm.get('regon').hasError('minlength') ||
                          companyForm.get('regon').hasError('pattern')">
          Niepoprawny numer REGON
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>
          Zewnętrzne ID
        </mat-label>
        <input matInput formControlName="individualNumber" id="individualNumber"/>
      </mat-form-field>
    </div>
    <app-new-address label="Adres siedziby"
                     formControlName="mainAddress"
                     [fixedAddressType]="AddressType.MAIN" [required]="true"></app-new-address>
    <app-new-address label="Adres korespondencyjny"
                      formControlName="correspondenceAddress"
                     [fixedAddressType]="AddressType.CORRESPONDENCE"></app-new-address>
  </form>
</div>
